import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function MrbNotificationContainer(props) {
    return <ToastContainer {...props}></ToastContainer>;
}

export default MrbNotificationContainer;
